import FormSection from './FormSection'
import { translations } from '../../data/translations'

const PerformanceSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.performance || translations.de.performance

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 11.1 Hosting-Anforderungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="form-group">
          <label>{t.hostingStatus} <span className="required">*</span></label>
          <div className="radio-group">
            {t.hostingStatusOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`host-${option.value}`}
                  name="hosting_status"
                  value={option.value}
                  checked={formData.hosting_status === option.value}
                  onChange={(e) => updateFormData('hosting_status', e.target.value)}
                />
                <label htmlFor={`host-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>{t.hostingTyp}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
            {t.hostingTypOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`ht-${option.value}`}
                  checked={(formData.hosting_typ || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('hosting_typ', option.value)}
                />
                <label htmlFor={`ht-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
          <div className="help-text">{t.hostingTypHelp}</div>
        </div>

        <div className="form-group">
          <label>{t.emailHosting}</label>
          <div className="radio-group">
            {t.emailHostingOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`email-${option.value}`}
                  name="email_hosting"
                  value={option.value}
                  checked={formData.email_hosting === option.value}
                  onChange={(e) => updateFormData('email_hosting', e.target.value)}
                />
                <label htmlFor={`email-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 11.2 Performance-Erwartungen */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="form-group">
          <label>{t.traffic} <span className="required">*</span></label>
          <div className="radio-group">
            {t.trafficOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`traffic-${option.value}`}
                  name="traffic"
                  value={option.value}
                  checked={formData.traffic === option.value}
                  onChange={(e) => updateFormData('traffic', e.target.value)}
                />
                <label htmlFor={`traffic-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>{t.performanceAnforderungen}</label>
          <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {t.performanceOptionen.map(option => (
              <div key={option.value} className="checkbox-item">
                <input
                  type="checkbox"
                  id={`perf-${option.value}`}
                  checked={(formData.performance || []).includes(option.value)}
                  onChange={() => handleCheckboxChange('performance', option.value)}
                />
                <label htmlFor={`perf-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </FormSection>
  )
}

export default PerformanceSection
